<template>
  <v-table>
    <thead>
      <tr>
        <th class="pa-3 text-subtitle-1 font-weight-bold text-center">月</th>
        <th class="pa-3 text-subtitle-1 font-weight-bold text-center">最低気温</th>
        <th class="pa-3 text-subtitle-1 font-weight-bold text-center">最高気温</th>
        <th class="pa-3 text-subtitle-1 font-weight-bold text-center">降水量</th>
        <th class="pa-3 text-subtitle-1 font-weight-bold text-center">降水日数</th>
      </tr>
    </thead>
    <tbody class="no-select">
      <tr v-for="row in monthlyData" :key="row.month">
        <td align="center" class="px-2">{{ row.month }}月</td>
        <td align="right" class="px-2">{{ row.low }}°C</td>
        <td align="right" class="px-2">{{ row.high }}°C</td>
        <td align="right" class="px-2">{{ row.rainFall }}mm</td>
        <td align="right" class="px-2">{{ row.rainDays }}日</td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
export default {
  name: 'MonthlyData',
  props: [ 'monthlyData' ]
}
</script>

<style>
thead {
  background-color: #7A91BC;
  color: #fff;
}
tbody tr:nth-of-type(odd) {
  background-color: #0000000d;
}
tbody tr:hover {
  background: #e6e6e6;
}
tbody td {
  font-size: 16px;
  width: calc(100%/5);
}

.no-select {
    /* Safari */
    -webkit-user-select: none;
    /* IE 10 and IE 11 */
    -ms-user-select: none;
    /* Standard syntax */
    user-select: none;
}
</style>
